export default "__VITE_ASSET__a92683fd__"